import { Box, Link, Typography } from '@mui/material';
import HighlightCard from '../components/HighlightCard';

const highlights = [
  {
    title: 'SWE @ Zip',
    events: [
      'Started in September 2025. Zip is a series-D startup aiming to modernize procurement.',
    ],
    icon: '💼',
  },
  {
    title: 'Waterloo CS Alumnus',
    events: [
      "Graduated with 3.95 GPA and awarded Dean's Honours.",
      'Earned highest evaluation rating for all six co-op placements.',
      'Recipient of four merit-based scholarships.',
    ],
    icon: '🎓',
  },
  {
    title: 'Current Sidequests',
    events: [
      'Dancer — member of RTF Black Ops.',
      'Proud dad of 25 plants (and counting!)',
      'Training to bench 225 and/or run a marathon.',
    ],
    icon: '🌱',
  },
];

const Highlights = () => (
  <Box
    component='section'
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      mb: 8,
    }}
  >
    {highlights.map(h => (
      <HighlightCard key={h.title} {...h} />
    ))}
  </Box>
);

export default Highlights;
